import React, { useState } from "react";
import { ListActionButtonProps, Aside } from "sprint-common-web";

import { EditListButton } from "../../../common/components/buttons/EditListButton";
import { DeliveryEndpointType } from "../../../common/types/DeliveryEndpointType";
import { DeliveryEndpointItem } from "../listing/DeliveryEndpointItem";
import { EditAsperaDeliveryEndpointForm } from "./aspera/EditAsperaDeliveryEndpointForm";
import { EditSigniantDeliveryEndpointForm } from "./signiant/EditSigniantDeliveryEndpointForm";
import { EditSmartjogDeliveryEndpointForm } from "./smartjog/EditSmartjogDeliveryEndpointForm";

export interface EditDeliveryEndpointButtonProps {
    itemId: string;
    type: DeliveryEndpointType;
}

export const EditDeliveryEndpointButton: React.FC<ListActionButtonProps<DeliveryEndpointItem>> = (
    props: ListActionButtonProps<DeliveryEndpointItem>
) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
    const { itemId, item } = props;
    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };

    const openSidebar = () => {
        setIsSidebarOpen(true);
    };

    switch (item.type) {
        case DeliveryEndpointType.Smartjog:
            return (
                <>
                    <EditListButton onClick={openSidebar} disabled={false} />
                    <Aside isOpen={isSidebarOpen} type="form" headerText="Edit" onDismiss={closeSidebar}>
                        <EditSmartjogDeliveryEndpointForm
                            onSubmit={closeSidebar}
                            onCancel={closeSidebar}
                            deliveryEndpointId={itemId}
                        />
                    </Aside>
                </>
            );
        case DeliveryEndpointType.Aspera:
            return (
                <>
                    <EditListButton onClick={openSidebar} disabled={false} />
                    <Aside isOpen={isSidebarOpen} type="form" headerText="Edit" onDismiss={closeSidebar}>
                        <EditAsperaDeliveryEndpointForm
                            onSubmit={closeSidebar}
                            onCancel={closeSidebar}
                            deliveryEndpointId={itemId}
                        />
                    </Aside>
                </>
            );
        case DeliveryEndpointType.Signiant:
            return (
                <>
                    <EditListButton onClick={openSidebar} disabled={false} />
                    <Aside isOpen={isSidebarOpen} type="form" headerText="Edit" onDismiss={closeSidebar}>
                        <EditSigniantDeliveryEndpointForm
                            onSubmit={closeSidebar}
                            onCancel={closeSidebar}
                            deliveryEndpointId={itemId}
                        />
                    </Aside>
                </>
            );
    }
};
